import React from 'react'
import {AuthenticationService} from '../../../services'
import {showErrorToast, showSuccessToast} from '../../../state/toasts'
import {deleteAuthInfo} from '../../../state/auth'
import {useDispatch} from 'react-redux'
import {PasswordChangeForm} from './PasswordChangeForm'
import {PasswordChange} from '../../../api'

export const PasswordChangePage: React.FC = () => {
    const dispatch = useDispatch()

    const handleChangePassword = (values: PasswordChange): void => {
        AuthenticationService.changePassword(values)
            .then((response) => {
                dispatch(
                    showSuccessToast(
                        'Success',
                        'Your Password has been changed successfully.'
                    )
                )
                dispatch(deleteAuthInfo())
            })
            .catch((errors: any) => {
                const errorMessage =
                    errors.response?.data?.non_field_errors?.[0] ||
                    'Could not change password.'
                dispatch(showErrorToast('Error', errorMessage))
            })
    }

    return (
        <div className=" mx-auto col-sm-12 col-md-4">


            <PasswordChangeForm onSubmit={handleChangePassword}/>

        </div>
    )
}
